import { Box, Typography } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import {
  ArrayInput,
  BooleanInput,
  Edit,
  FormDataConsumer,
  FormTab,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TimeInput,
  required,
  useDataProvider,
} from 'react-admin';
import DateTimeInputUTC from '../../components/DateTimeInputUTC';
import { FuelAccordion } from '../../components/FuelAccordion';
import Permission from '../../components/Permission';
import { PERMISSIONS, daysOfTheWeek, frequencyChoices } from '../../constants';
import { getChainId } from '../../lib';

const dailyContainerSx = {
  display: 'flex',
  gap: 30,
  marginBottom: 20
};

const dateTimePickerSx = {
  display: 'flex',
  gap: 20,
};

const inputWrapperStyleSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  margin: '0 0 20px 0',
};

const inputSx = {
  margin: '0 20px 0 0',
};

const selectsAllPlacesButtonSx = {
  marginTop: '20px',
};

const daySx = {
  fontSize: 16,
  margin: '20px 0'
};

const FuelScheduledDiscountEdit = (props) => {

  const dataProvider = useDataProvider();
  const [chainId, setChainId] = useState(getChainId());
  const [placeIds, setPlaceIds] = useState();
  const [placeChoices, setPlaceChoices] = useState([]);
  const [selectsAllPlaces, setselectsAllPlaces] = useState(false);
  const [fuels, setFuels] = useState();
  const [frequency, setFrequency] = useState();

  useEffect(() => {
    if (chainId) {
      if (placeChoices && placeChoices.length) {
        if (placeIds && placeIds.length || selectsAllPlaces) {
          dataProvider.getList('fuels', {
            sort: {
              field: 'name',
              order: 'ASC'
            },
            filter: { placeIds: selectsAllPlaces ? placeChoices.map(place => place.id) : placeIds }
          })
            .then(res => {
              setFuels(res && res.data);
            });
        } else {
          setFuels([]);
        }
      }
    }
  }, [placeChoices, placeIds, selectsAllPlaces]);

  useEffect(() => {
    if (chainId) {
      dataProvider.getList('stations', { sort: { field: 'name', order: 'ASC' }, filter: { chainId } }).then(res => {
        setPlaceChoices(res.data);
      });
    }
  }, [chainId]);

  const transform = data => {
    data.fuelScheduledDiscounts = data.fuelScheduledDiscounts.filter(f => f && f.fuelId);
    return data;
  };

  return (
    <Permission permission={PERMISSIONS.FUEL_DISCOUNTS}>
      <Edit {...props} title="Editar desconto agendado" transform={transform} >
        <TabbedForm>
          <FormTab label="Descontos">

            {!getChainId() &&
              <ReferenceInput label="Rede" source="chainId" reference="chains" onChange={({ target: { value } }) => setChainId(value)}>
                <SelectInput resettable optionText="name" />
              </ReferenceInput>
            }
            {chainId && (
              <FormDataConsumer>
                {({ formData }) => {
                  if (formData.selectsAllPlaces) {
                    setselectsAllPlaces(formData.selectsAllPlaces);
                  } else if (formData.placeIds) {
                    setPlaceIds(formData.placeIds);
                  }
                  setFrequency(formData.frequency);

                  return (
                    <>
                      <div style={{ display: 'flex' }}>
                        {
                          !selectsAllPlaces &&
                          <SelectArrayInput
                            label="Postos"
                            style={{ minWidth: 180, marginRight: 20 }}
                            optionText={'name'}
                            source={"placeIds"}
                            onChange={({ target: { value } }) => setPlaceIds(value)}
                            choices={placeChoices}
                          />
                        }
                        <BooleanInput
                          source="selectsAllPlaces"
                          label="Selecionar todos os postos"
                          sx={selectsAllPlacesButtonSx}
                          onChange={value => setselectsAllPlaces(value)}
                        />
                      </div>
                      <BooleanInput label="Sobrepor desconto de grupo" source="overlapsGroupDiscount" />
                    </>
                  )
                }}
              </FormDataConsumer>
            )}
            {chainId && fuels &&
              <FormDataConsumer>
                {({ formData: { fuelScheduledDiscounts } }) => {
                  return fuels.map((fuel) => {
                    let index;
                    if (fuelScheduledDiscounts && fuelScheduledDiscounts.length) {
                      index = fuelScheduledDiscounts.findIndex(fsd => fsd.fuelId === fuel.id);
                      if (index === -1) {
                        fuelScheduledDiscounts.push({
                          fuelId: fuel.id,
                          scheduledDiscountId: props.id,
                        });
                        index = fuelScheduledDiscounts.length;
                      }
                    }
                    return (
                      <FuelAccordion
                        name={fuel.name}
                        source={`fuelScheduledDiscounts[${index}]`}
                        hideAmount={
                          fuelScheduledDiscounts && fuelScheduledDiscounts[index] ? fuelScheduledDiscounts[index].uniqueDiscountValue : true
                        }
                      />
                    )
                  });
                }}
              </FormDataConsumer>
            }
          </FormTab>
          <FormTab label="Agendamento">
            <>
              <Box sx={dateTimePickerSx}>
                <DateTimeInputUTC
                  source="startDate"
                  label="Data de Início"
                  validate={[required()]}
                />
                <DateTimeInputUTC
                  source="endDate"
                  label="Data Final"
                  validate={[required()]}
                />
              </Box>
              <SelectInput
                label="Frequência"
                source="frequency"
                alwaysOn
                style={{ marginTop: 10 }}
                choices={frequencyChoices}
                onChange={({ target: { value } }) => setFrequency(value)}
                validate={[required()]}
              />

              {frequency === 'daily' &&
                <Box sx={dailyContainerSx}>
                  <TimeInput
                    source="dayScheduledDiscounts[0].startTime"
                    label="Horário inicial"
                    style={{ width: 200 }}
                    isRequired
                    validate={[required()]}
                    parse={value => value.toString()}
                  />
                  <TimeInput
                    source="dayScheduledDiscounts[0].endTime"
                    label="Horário final"
                    style={{ width: 200 }}
                    isRequired
                    validate={[required()]}
                    parse={value => value.toString()}
                  />
                </Box>
              }
              {frequency === 'weekly' &&
                <FormDataConsumer>
                  {({ formData }) => {
                    if (formData.dayScheduledDiscounts) {
                      if (formData.dayScheduledDiscounts.length !== 7) {
                        const registeredDays = formData.dayScheduledDiscounts.map(record => {
                          record.isActive = true;
                          return record.dayOfTheWeek;
                        });
                        const notRegisteredDays = [...daysOfTheWeek].filter(wd => !registeredDays.includes(wd.id));
                        notRegisteredDays.forEach(day => {
                          formData.dayScheduledDiscounts.push({
                            dayOfTheWeek: day.id,
                            isActive: false
                          });
                        });
                      }
                      formData.dayScheduledDiscounts.sort((a, b) => {
                        if (a.dayOfTheWeek > b.dayOfTheWeek) {
                          return 1;
                        } else if (a.dayOfTheWeek < b.dayOfTheWeek) {
                          return -1;
                        }
                        return 0;
                      });
                    }

                    return (
                      <ArrayInput source="dayScheduledDiscounts" label="Defina os dias e horários">
                        <SimpleFormIterator disableAdd disableRemove disableReordering>
                          <FormDataConsumer>
                            {({ scopedFormData }) => {
                              const day = daysOfTheWeek.find(day => scopedFormData && day.id === scopedFormData.dayOfTheWeek);
                              return (
                                <>
                                  {
                                    <Typography sx={daySx}>{day && day.name}</Typography>
                                  }
                                  <Box sx={inputWrapperStyleSx}>
                                    <BooleanInput
                                      source="isActive"
                                      label={false}
                                      sx={inputSx}
                                    />
                                    {scopedFormData && scopedFormData.isActive &&
                                      <Fragment>
                                        <TimeInput
                                          record={scopedFormData}
                                          label='Horário inicial'
                                          source="startTime"
                                          style={{ marginRight: 20, width: 200 }}
                                          isRequired
                                          parse={value => value.toString()}
                                        />
                                        <TimeInput
                                          record={scopedFormData}
                                          label='Horário final'
                                          source="endTime"
                                          style={{ marginRight: 20, width: 200 }}
                                          isRequired
                                          parse={value => value.toString()}
                                        />
                                      </Fragment>
                                    }
                                  </Box>
                                </>
                              );
                            }}
                          </FormDataConsumer>
                        </SimpleFormIterator>
                      </ArrayInput>
                    );
                  }}
                </FormDataConsumer>
              }
            </>
          </FormTab>
        </TabbedForm>
      </Edit>
    </Permission >
  );
}

export default FuelScheduledDiscountEdit;